const fixedMenu = () => {

	const menuFixed = document.querySelector('[data-block="header"]');
	let bodyBlock = document.querySelector('.body');
	let blockHeight = menuFixed.clientHeight + 50;

	try {
		addEventListener('scroll', ()=>{
			if(window.pageYOffset > blockHeight){
	 			menuFixed.classList.add('menu-fixed');
	 			bodyBlock.style.paddingTop = menuFixed.clientHeight + 90 + 'px';
			} else {
				menuFixed.classList.remove('menu-fixed');
				bodyBlock.style.paddingTop = 0;
			}
		});
	} catch(e){}


};

export default fixedMenu;